// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card[data-v-10117664]{margin-top:5rem;padding:5rem;min-width:600px}", ""]);
// Exports
module.exports = exports;
